module.exports = __webpack_public_path__ + "static/media/image 17.54c40cb3.png";